(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('towerInstallation', {
            parent: 'app',
            url: '/towerInstallation',
            data: {
                authorities: ['ROLE_TOWER_DC', 'ROLE_TOWER_NODAL_OFFICER', 'ROLE_TOWER_DEPARTMENT'],
                pageTitle: 'global.menu.towerInstallation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/towerInstallation/towerInstallation.html',
                    controller: 'TowerInstallationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerInstallation');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
